var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1118_29472)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FFA024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 23H27V17C27 16.7348 26.8946 16.4804 26.7071 16.2929C26.5196 16.1054 26.2652 16 26 16C25.7348 16 25.4804 16.1054 25.2929 16.2929C25.1054 16.4804 25 16.7348 25 17V23H19C18.7348 23 18.4804 23.1054 18.2929 23.2929C18.1054 23.4804 18 23.7348 18 24C18 24.2652 18.1054 24.5196 18.2929 24.7071C18.4804 24.8946 18.7348 25 19 25H25V31C25 31.2652 25.1054 31.5196 25.2929 31.7071C25.4804 31.8946 25.7348 32 26 32C26.2652 32 26.5196 31.8946 26.7071 31.7071C26.8946 31.5196 27 31.2652 27 31V25H33C33.2652 25 33.5196 24.8946 33.7071 24.7071C33.8946 24.5196 34 24.2652 34 24C34 23.7348 33.8946 23.4804 33.7071 23.2929C33.5196 23.1054 33.2652 23 33 23Z",
    fill: "#F9F9FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1118_29472",
    x: 0,
    y: -1,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1118_29472"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1118_29472",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateOrder);
export default __webpack_public_path__ + "static/media/createOrder.b3a8530707efe2572c3e386c68ffdb1c.svg";
export { ForwardRef as ReactComponent };